import React from "react";
import { Date, Text } from "@common/formx";
import locale from "@bonliva-crm/locale";
import { FieldProps as FieldPropsBase } from "@consultants/ConsultantContract/DynamicFieldsGroup";
import yup from "yup";
import { moment } from "@bonliva-crm/common";
import { SnapshotFormStore, FormData } from "./SnapshotFormStore";
import { UserAvatarChip } from "@containers";
import ConsultantSelector from "@containers/VirtualSelector/ConsultantSelector/ConsultantSelector";
import { Button, FormControl, FormLabel, Grid, Typography } from "@material-ui/core";
import { store } from "@store";
import { Select } from "@common/formx_item_form";

type FieldProps = FieldPropsBase<FormData, SnapshotFormStore>;

const field = ({
  name,
  order = 0,
  show = () => true,
  schema,
  isGroup = false,
  gridProps,
  xs = 4,
  md,
  render
}: FieldProps) => ({ name, order, show, schema, isGroup, gridProps, xs, md, render });

export const customer: FieldProps = field({
  name: "customerId",
  xs: 12,
  schema: yup.string().nullable(true).required(locale.fieldIsMandatory(locale.Customer)),
  render: (form, { store }) => (
    <Select
      fullWidth
      id="person"
      label={locale.Customer}
      name={"customerId"}
      options={store.customers.toLabelValue(
        (x) => x.Name,
        (x) => x._id
      )}
    />
  )
});

export const consultant: FieldProps = field({
  name: "consultantId",
  xs: 12,
  render: (form, { store }) => {
    const ConsultantId = form.getValue("consultantId");
    const value = ConsultantId
      ? {
          label: "",
          value: ConsultantId
        }
      : null;
    return (
      <ConsultantSelector
        clearable
        error={form.getError("consultantId")}
        fullWidth
        required
        onChange={store.setConsultant}
        value={value as any}
      />
    );
  }
});

export const invoiceMarking: FieldProps = field({
  name: "invoiceMarking",
  xs: 12,
  render: (form, { store }) => {
    return <Text name="invoiceMarking" label={locale.invoiceMarking} />;
  }
});

export const contactPerson: FieldProps = field({
  xs: 12,
  name: "contactPersonId",
  schema: yup
    .string()
    .nullable(true)
    .required(locale.fieldIsMandatory(locale["Contact person"])),
  render: (form, { store: { allOfContactPerson } }) => {
    return (
      <Grid container item spacing={2} key={"contact person"}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <FormLabel htmlFor="person">
              <div style={{ display: "flex", alignItems: "center", fontSize: 12 }}>
                {locale["Contact person"]}
              </div>
            </FormLabel>
            <Select
              fullWidth
              id="person"
              label={""}
              name={"contactPersonId"}
              options={allOfContactPerson.toLabelValue(
                (x) => x.title || x.name,
                (x) => x._id
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }
});

export const responsiblePerson: FieldProps = field({
  xs: 12,
  name: "responsiblePersonId",
  schema: yup
    .string()
    .required(locale.fieldIsMandatory(locale["Responsible BA"]))
    .nullable(true),
  render: (form) => {
    return (
      <div>
        <Typography variant="h6" gutterBottom>
          {form.getError("responsiblePersonId") ? (
            <span style={{ color: "#F65629" }}>
              {form.getError("responsiblePersonId")}
            </span>
          ) : (
            locale.SelectContactPerson2
          )}
        </Typography>

        <Button
          variant="contained"
          color="secondary"
          onClick={() =>
            store().ui.userSelector.open({
              includeActiveUser: true,
              removeDisabled: true,
              selectedUsers: [form.values.responsiblePersonId],
              onSelect: (user) => {
                form.setValue("responsiblePersonId", user._id);
              }
            })
          }
        >
          {locale.Select}
        </Button>

        {form.values.responsiblePersonId && (
          <span style={{ paddingLeft: 10 }}>
            <UserAvatarChip size="normal" />
          </span>
        )}
      </div>
    );
  }
});

export const signedOn: FieldProps = field({
  name: "SignedOn",
  xs: 8,
  schema: yup.string().nullable(true).required(" "),
  render: (form) => {
    const label = locale.SignedOn;
    return (
      <Date
        utc
        key={"SignedOn"}
        DatePickerProps={{
          startDate: moment().toDate(),
          shouldCloseOnSelect: true,
          placeholder: label
        }}
        name="SignedOn"
        // transformValue={v => moment(v).format("YYYY-MM-DD")}
        label={label}
      />
    );
  }
});
